<template>
  <div class="page">
    <div v-if="Orientation=='H'">
      <div class="tips">
        <div style="color: #666666">·为了更好的使用，请锁定手机方向</div>
        <div style="color: #666666">·请在黑框内签署姓名</div>
      </div>
      <div class="bg-text">
        签名区域
      </div>
      <div class="bottom">
        <div class="bottom-btn back" @click="back">返回</div>
        <div class="bottom-btn clear" @click="handleReset">清空</div>
        <div class="bottom-btn next" @click="handleGenerate">确认</div>
      </div>
      <div class="canvas-view">
        <vue-esign
          ref="esign"
          class="mySign"
          :width="canvasWidth"
          :height="canvasHeight"
          :isCrop="isCrop"
          :lineWidth="lineWidth"
          :lineColor="lineColor"
          :bgColor.sync="bgColor"
        />
      </div>

    </div>
    <div  v-if="Orientation=='W'">
      <div class="tips-W">
        <div style="color: #666666">·为了更好的使用，请锁定手机方向</div>
        <div style="color: #666666">·请在黑框内签署姓名</div>
      </div>
      <div class="bg-text-W">
        签名区域
      </div>
      <div class="bottom-W">
        <div class="bottom-btn back" @click="back">返回</div>
        <div class="bottom-btn clear" @click="handleReset">清空</div>
        <div class="bottom-btn next" @click="handleGenerate">确认</div>
      </div>
      <div class="canvas-view-W">
        <vue-esign
          ref="esign"
          class="mySign"
          :width="canvasWidth"
          :height="canvasHeight"
          :isCrop="isCrop"
          :lineWidth="lineWidth"
          :lineColor="lineColor"
          :bgColor.sync="bgColor"
        />
      </div>
    </div>

  </div>

</template>

<script>

var obj = require("@/api/api.js");
export default {
  name: "face",
  data(){
    return {
      canvasWidth:0,
      canvasHeight:0,
      dialogVisible: false, // 弹框是否开启
      lineWidth: 6, // 画笔的线条粗细
      lineColor: "#000000", // 画笔的颜色
      bgColor: "", // 画布的背景颜色
      resultImg: "", // 最终画布生成的base64图片
      isCrop: false, // 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
      Orientation:'H',
      registno:'',
      policyno:''
    };
  },
  created() {
    this.registno = this.$route.query.registno
    this.policyno = this.$route.query.policyno
    let _this = this
    this.checkOrientation()
    this.Orientation = screen.orientation.type=='landscape-primary'?'W':'H'
    if(this.Orientation == 'H'){
      _this.canvasWidth =  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      _this.canvasHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight ;
      _this.canvasWidth = _this.canvasWidth - 50
    }else{
      _this.canvasWidth =  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      _this.canvasHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight ;
      _this.canvasHeight = _this.canvasHeight - 50
      _this.$forceUpdate()
      console.log("横屏");
    }
    console.log(screen.orientation.type)

    window.addEventListener('orientationchange', function() {
      // _this.checkOrientation()
      // 处理翻转事件
      console.log("设备方向已改变");
      console.log("当前方向：", screen.orientation.type);
      if( screen.orientation.type=='landscape-primary'){
        _this.Orientation = ''
        setTimeout(()=>{
          _this.Orientation = 'W'
          _this.canvasWidth =  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          _this.canvasHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight ;
          _this.canvasHeight = _this.canvasHeight - 50
          _this.$forceUpdate()
          console.log("横屏");
        },500)


      }else{
        _this.Orientation = ''
        setTimeout(()=>{
          _this.Orientation = 'H'
          _this.canvasWidth =  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          _this.canvasHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight ;
          _this.canvasWidth = _this.canvasWidth - 50
          _this.$forceUpdate()
          console.log("竖屏");
        },500)

      }
    });
  },
  methods:{
    getDateTime(){
      let date = new Date()
      let y = date.getFullYear()
      let d = date.getDate()
      let m = date.getMonth() +1
      return `${y}年${m}月${d}日`
    },
    back(){
      this.$router.go(-1)
      console.log('fanhui')
    },
    checkOrientation(){
      if (window.matchMedia("(orientation: portrait)").matches) {
        console.log("竖屏");

      } else {
        console.log("横屏");
        this.Orientation = 'W'
      }
    },
    // 清空画板
    handleReset() {
      console.log(66)
      this.$refs.esign.reset();
    },
    upload(base64){
      let param = {
        fileBase64:base64,
        fileName:'客户签名.png',
        systemId:'system01',
        busType:'prpall'
      }
      this.$http
        .post(obj.upload, param).then((res) => {

        if(res.data.rtnCode=='0000'){
          console.log('图片上传成功')
          this.verifyconfirm(res.data)
        }else{
          this.$indicator.close()
          alert('签名图片上传失败，请重试')
        }
      });
    },
    verifyconfirm(data){
      let param = {
        "policyno":this.policyno,
        "businessno": this.registno,
        "signdate": this.getDateTime(),
        "signfileid": data.fileId,
        "signfileurl": data.fileUrl,
      }
      this.$http
        .post(obj.verifyconfirm, param).then((res) => {
        this.$indicator.close()
          if(res.data.rtnCode=='0000'){
            this.$router.push({path:'/face/nameEnd',query:{
                registno:this.registno,
                type:this.type
              }})
          }else{
            this.$messagebox({
              type: "error",
              message: res.data.rtnMsg,
            });
            // alert(res.data.rtnMsg)
          }
      })
    },
    rotateBase64Img(src, edg, callback) {
    let _this = this
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");

      var imgW;//图片宽度
      var imgH;//图片高度
      var size;//canvas初始大小

      if (edg % 90 != 0) {
        console.error("旋转角度必须是90的倍数!");
        throw '旋转角度必须是90的倍数!';
      }
      (edg < 0) && (edg = (edg % 360) + 360)
      const quadrant = (edg / 90) % 4; //旋转象限
      const cutCoor = {sx: 0, sy: 0, ex: 0, ey: 0}; //裁剪坐标

      var image = new Image();
      image.crossOrigin = "anonymous"
      image.src = src;

      image.onload = function () {

        imgW = image.width;
        imgH = image.height;
        size = imgW > imgH ? imgW : imgH;

        canvas.width = size * 2;
        canvas.height = size * 2;
        switch (quadrant) {
          case 0:
            cutCoor.sx = size;
            cutCoor.sy = size;
            cutCoor.ex = size + imgW;
            cutCoor.ey = size + imgH;
            break;
          case 1:
            cutCoor.sx = size - imgH;
            cutCoor.sy = size;
            cutCoor.ex = size;
            cutCoor.ey = size + imgW;
            break;
          case 2:
            cutCoor.sx = size - imgW;
            cutCoor.sy = size - imgH;
            cutCoor.ex = size;
            cutCoor.ey = size;
            break;
          case 3:
            cutCoor.sx = size;
            cutCoor.sy = size - imgW;
            cutCoor.ex = size + imgH;
            cutCoor.ey = size + imgW;
            break;
        }


        ctx.translate(size, size);
        ctx.rotate(edg * Math.PI / 180);
        ctx.drawImage(image, 0, 0);

        var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
        if (quadrant % 2 == 0) {
          canvas.width = imgW;
          canvas.height = imgH;
        } else {
          canvas.width = imgH;
          canvas.height = imgW;
        }
        ctx.putImageData(imgData, 0, 0);
        // console.log(canvas.toDataURL())
        _this.resultImg = canvas.toDataURL()
        _this.upload(_this.resultImg)
      };
    },
    // 生成签字图
    handleGenerate() {
      console.log(1234)
      let _this = this
      this.$indicator.open({
        spinnerType: 'double-bounce',
      });

      this.$refs.esign
        .generate() // 使用生成器调用把签字的图片转换成为base64图片格式
        .then((res) => {
          _this.resultImg = res;
          if(this.Orientation=='H'){
            _this.rotateBase64Img(_this.resultImg,270)
          }
        })
        .catch((err) => {
          // 画布没有签字时会执行这里提示一下
          _this.$messagebox({
            type: "warning",
            message: "请签名后再生成签字图片",
          });
          _this.$indicator.close()
        });

      // 在这里向后端发请求把转换后的base64文件传给后端，后端接收以后再转换成图片做静态图片存储
      // 当然也可以把base64转成流文件blob格式的，类似上传给后端这样，具体哪种方式看后端要求
      setTimeout(() => {
        // 这里要使用定时器稍微延后以后就能取到base64数据了，当然也可以再加一个确认按钮，如：确认使用这张base64签名图片
        // 点击确认以后，在其回调函数中，再把base64的签名图片传给后端用于存储


          console.log('我是签字后的base64图片',this.resultImg);

      }, 500);
      this.dialogVisible = false;
    },
  }
}
</script>
<style>
body{
  font-size: 14px !important;
}
.mint-indicator{
  position: fixed;
  z-index: 10000;
}
</style>
<style lang="scss" scoped>
.page{
  width: 100%;
  height: 100%;
  //display: flex;
}
.tips-W{
  font-size: 14px;
  position: fixed;
  left: 10px;
  top: 10px;
}

.bg-text-W{
  width: 98vw !important;
  height: calc(100vh - 60px) !important;
  line-height: calc(100vh - 60px) !important;
  position: fixed;
  right: 10px;
  text-align: center;
  top: 1vh;
  font-size: 12vw;
  z-index: 1;
  color: #ebebeb;
}

.canvas-view{
  width: calc(100vw - 60px) !important;
  height: 100vh !important;
  position: fixed;
  //background-color: #2b9c00;
  right: 10px;
  top: auto;
  z-index: 100;
  bottom: auto;
}
.bg-text{
  width: calc(100vw - 60px) !important;
  height: 100vh !important;
  line-height: 100vh !important;
  transform: rotate(90deg);
  position: fixed;
  right: 10px;
  text-align: center;
  top: 1vh;
  font-size: 12vw;
  z-index: 1;
  color: #ebebeb;
}
.tips{
  font-size: 14px;
  position: fixed;
  right: -220px;
  top: 15px;
  width: 230px;
  //background-color: #2b9c00;
  transform: rotate(90deg);
  transform-origin: top left;
}
.canvas-view-W{
  width: 98vw !important;
  height: calc(100vh - 60px) !important;
  z-index: 100;
  position: fixed;

  //background-color: #2b9c00;

}
.mySign{
  margin-left: 1vw;
  margin-top: 1vh;
  border: #666666 2px solid;
}
.bottom{
  width: calc(100vh - 10px);
  //width: 60px;
  position: fixed;
  top: 5px;
  z-index: 99;
  left: 45px;
  transform: rotate(90deg);
  transform-origin: top left;
  margin-left: 5px;
  height: 50px;
  //height: calc(100vh - 10px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  .bottom-btn{
    width: 33%;
    height: 40px;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    color: white;
    border-radius: 5px;
  }
  .back{
    background: linear-gradient(to bottom, #f9ae61, #d37f00);
  }
  .next{
    background: linear-gradient(to bottom,#87f75c,#2b9c00);
  }
  .clear{
    background: linear-gradient(to bottom, #89c0e7, #2d84dd);
  }
}
.bottom-W{
  width: calc(100vw - 10px);
  position: fixed;
  bottom: 5px;
  margin-left: 5px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .bottom-btn{
    width: 33%;
    height: 40px;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    color: white;
    border-radius: 5px;
  }
  .back{
    background: linear-gradient(to bottom, #f9ae61, #d37f00);
  }
  .next{
    background: linear-gradient(to bottom,#87f75c,#2b9c00);
  }
  .clear{
    background: linear-gradient(to bottom, #89c0e7, #2d84dd);
  }
}
#app {

  .checkMan {
    width: 400px;
    height: 360px;
    text-align: center;
    border: 1px solid #e9e9e9;
    padding-top: 40px;
    h2 {
      margin-bottom: 20px;
    }
    //.el-button {
    //  margin-bottom: 20px;
    //}
    img {
      width: 100%;
      height: 100vh;
    }
  }
}
/deep/ .el-dialog__body {
  // 设置一下签字区域的虚线边框
  .mySign {
    border: 1px dashed #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/face/name.vue